"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modelProperties = {
    modelName: 'Media',
    tableName: 'Media',
    validations: {
        name: { type: 'length', max: 60 },
        filename: { type: 'length', max: 255 },
        url: { type: 'length', max: 255 },
        status: { type: 'length', max: 32 },
    },
};
exports.default = modelProperties;
//# sourceMappingURL=../../../../src/models/media/modelProperties.js.map